"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROCESS_CONTEXT = exports.DATA_TEST_ID = exports.ACCEPT_LANGUAGE = void 0;
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'Accept-Language';
const DATA_TEST_ID = exports.DATA_TEST_ID = 'data-testid';
const PROCESS_CONTEXT = exports.PROCESS_CONTEXT = 'x-process-context';
